module.exports = __webpack_public_path__ + "img/zabix.9c8e5b52.jpg";